import { formatDateTime } from "./ui";

const EVENT_LABELS = {
  created: "Quote created",
  sent: "Quote sent",
  viewed: "Quote viewed",
  accepted: "Quote accepted",
  declined: "Quote declined",
  organization_created: "Organization created",
};

export default function QuoteTimeline({ events }) {
  if (!events || events.length === 0) return null;
  return (
    <div data-testid="quote-timeline">
      <h3 className="text-sm font-bold text-slate-950 dark:text-white">Timeline</h3>
      <div className="mt-3 space-y-2">
        {events.map((event, idx) => (
          <div key={idx} className="flex items-center justify-between rounded-xl border border-slate-200 px-4 py-2.5 text-sm dark:border-white/10" data-testid={`quote-event-${idx}`}>
            <span className="font-semibold text-slate-800 dark:text-slate-200">{EVENT_LABELS[event.type] || event.type}</span>
            <span className="text-slate-500 dark:text-slate-400">{formatDateTime(event.at)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
